import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$urlRouterProvider',
  '$locationProvider',
  'cfpLoadingBarProvider',
  'IdleProvider',
  function (
    runtimeConstant,
    $urlRouterProvider,
    $locationProvider,
    cfpLoadingBarProvider,
    IdleProvider
  ) {
    function run() {
      try {
        $urlRouterProvider.deferIntercept();

        //Define o selector do componente para exibição da barra de carregamento
        cfpLoadingBarProvider.parentSelector = '.actions-card';

        // Configure Idle settings
        IdleProvider.idle(10); // in seconds
        IdleProvider.timeout(220); // in seconds

        $urlRouterProvider.otherwise('/');
        $locationProvider.hashPrefix('');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
